module.exports = __webpack_public_path__ + "static/media/6-Y.0417e67d.mp3";